/* [[ AUTO GENERATED - DO NOT MODIFY ]] */

export const GoogleBusinessMetrics = {
    WEBSITE_CLICKS: 'WEBSITE_CLICKS',
    CALL_CLICKS: 'CALL_CLICKS',
    DIRECTIONS_CLICKS: 'BUSINESS_DIRECTION_REQUESTS',
    IMPRESSIONS_DESKTOP_MAPS: 'BUSINESS_IMPRESSIONS_DESKTOP_MAPS',
    IMPRESSIONS_MOBILE_MAPS: 'BUSINESS_IMPRESSIONS_MOBILE_MAPS',
    IMPRESSIONS_DESKTOP_SEARCH: 'BUSINESS_IMPRESSIONS_DESKTOP_SEARCH',
    IMPRESSIONS_MOBILE_SEARCH: 'BUSINESS_IMPRESSIONS_MOBILE_SEARCH'
};
